import { TransferTypeEnum } from "@payping/api/app/api/cashOutTypes";
import { useAppTranslation } from "./useAppTranslation";

export const useTransferLabel = () => {
  const { t } = useAppTranslation();

  const getLabelTransfer = (transferType: TransferTypeEnum) => {
    switch (transferType) {
      case TransferTypeEnum.AUTO:
        return t("settlement.type.auto");
      case TransferTypeEnum.NORMAL:
        return t("settlement.type.acountToAcount");
      case TransferTypeEnum.ACH:
        return t("settlement.type.paya");
      default:
        return "";
    }
  };

  return { getLabelTransfer };
};

export default useTransferLabel;
